import { render, staticRenderFns } from "./returnDetail.vue?vue&type=template&id=dc787952&"
import script from "./returnDetail.vue?vue&type=script&lang=js&"
export * from "./returnDetail.vue?vue&type=script&lang=js&"
import style0 from "./returnDetail.vue?vue&type=style&index=0&id=dc787952&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports